import { render, staticRenderFns } from "./OaApprovalPanel.vue?vue&type=template&id=b43a21a8&scoped=true"
import script from "./OaApprovalPanel.vue?vue&type=script&lang=js"
export * from "./OaApprovalPanel.vue?vue&type=script&lang=js"
import style0 from "./OaApprovalPanel.vue?vue&type=style&index=0&id=b43a21a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b43a21a8",
  null
  
)

export default component.exports